import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import advertCardListCounterCss from './assets/advert-card-list-counter.module.scss';

type PropsType = {
  total: number;
};

const AdvertCardListCounter: FC<PropsType> = ({
  total,
}) => {
  if (!total) {
    return null;
  }

  return (
    <div className={advertCardListCounterCss.advertListCounter}>
      <FormattedMessage defaultMessage="Founded:" />
      <span>
        {total}
      </span>
    </div>
  );
};

export { AdvertCardListCounter };
